/**
 * Exercise Video URLs - COMPLETE FIXED VERSION
 *
 * All videos from your public/videos/exercises/ folder properly mapped
 * Fixed naming inconsistencies and added missing mappings
 */

export const exerciseVideos = {
    // ===== CORE EXERCISES - FIXED MAPPINGS =====
    "AbRollouts": "/videos/exercises/abrollouts.mp4",
    "AbScissors": "/videos/exercises/abscissors.mp4",
    "AbsCrunchesDumbbells": "/videos/exercises/abscrunchesdumbbells.mp4",
    "AbsCrunchesDumbbellsLegs": "/videos/exercises/abscrunchesdumbbellslegs.mp4",
    "AbsInAndOut": "/videos/exercises/absinandout.mp4",

    // ===== CARDIO & CONDITIONING =====
    "AdvancedBoxJumps": "/videos/exercises/advancedboxjumps.mp4",
    "AirSquats": "/videos/exercises/airsquats.mp4",
    "AlternatingLungesWithDumbbells": "/videos/exercises/alternatinglungeswithdumbbells.mp4",
    "AmericanDumbbellSwing": "/videos/exercises/americandumbbellswing.mp4",

    // ===== SHOULDERS & ARMS =====
    "ArnoldPress": "/videos/exercises/arnoldpress.mp4",
    "AustralianPullUps": "/videos/exercises/australianpullups.mp4",

    // ===== BACK EXERCISES =====
    "BackExtensions": "/videos/exercises/backextensions.mp4",

    // ===== CHEST & TRICEP EXERCISES =====
    "BenchOrChairDips": "/videos/exercises/benchorchairdips.mp4",
    "BenchPress": "/videos/exercises/benchpress.mp4",
    "BentOverRows": "/videos/exercises/bentoverrows.mp4",

    // ===== ARM EXERCISES =====
    "BicepCurls": "/videos/exercises/bicepcurls.mp4",
    "BicepCurls2": "/videos/exercises/bicepcurls2.mp4",
    "BicycleCrunch": "/videos/exercises/bicyclecrunch.mp4",
    "BicycleCrunches": "/videos/exercises/bicyclecrunches.mp4",
    "BicycleCrunchesLegsLower": "/videos/exercises/bicyclecruncheslegslower.mp4",

    // ===== FULL BODY MOVEMENTS =====
    "BodyWeightSideToSide": "/videos/exercises/bodyweightsidetoside.mp4",
    "BoxJumps": "/videos/exercises/boxjumps.mp4",
    "BroadSkaterJumps": "/videos/exercises/broadskaterjumps.mp4",

    // ===== BURPEE VARIATIONS =====
    "BurpeePlusHillClimbers": "/videos/exercises/burpeeplushillclimbers.mp4",
    "BurpeePlusPushUpAndPress": "/videos/exercises/burpeepluspushupandpress.mp4",
    "BurpeeWithDumbbell": "/videos/exercises/burpeewithdumbbell.mp4",

    // ===== CABLE & MACHINE EXERCISES =====
    "CableCrossovers": "/videos/exercises/cablecrossovers.mp4",
    "CableCrunches": "/videos/exercises/cablecrunches.mp4",
    "CalfPressOnLegPressMachine": "/videos/exercises/calfpressonlegpressmachine.mp4",
    "CalfRaises": "/videos/exercises/calfraises.mp4",

    // ===== TRICEP EXERCISES =====
    "ChairTricepExtension": "/videos/exercises/chairtricepextension.mp4",
    "ChestPressMachine": "/videos/exercises/chestpressmachine.mp4",

    // ===== STRETCHING & YOGA =====
    "ChildsPose": "/videos/exercises/childspose.mp4",

    // ===== PULL-UP VARIATIONS =====
    "ChinUps": "/videos/exercises/chinups.mp4",
    "ChinUps2": "/videos/exercises/chinups2.mp4",
    "ChinUpsOneArmLeft": "/videos/exercises/chinupsonearmleft.mp4",
    "ChinUpsOneArmRight": "/videos/exercises/chinupsonearmright.mp4",

    // ===== HIP & GLUTE EXERCISES =====
    "ClamshellExercise": "/videos/exercises/clamshellexercise.mp4",
    "ClappingPushUps": "/videos/exercises/clappingpushups.mp4",
    "CouchStretch": "/videos/exercises/couchstretch.mp4",
    "CrabWalk": "/videos/exercises/crabwalk.mp4",

    // ===== CORE EXERCISES =====
    "CrossLeggedSeatedRaises": "/videos/exercises/crossleggedseatedraises.mp4",
    "CrunchAndPunch": "/videos/exercises/crunchandpunch.mp4",
    "Crunches": "/videos/exercises/crunches.mp4",
    "Crunches2": "/videos/exercises/crunches2.mp4",

    // ===== FUNCTIONAL MOVEMENTS =====
    "DeadBugs": "/videos/exercises/deadbugs.mp4",

    // ===== DEADLIFT - FIXED! =====
    "DeadLift": "/videos/exercises/deadlift.mp4",
    "Deadlift": "/videos/exercises/deadlift.mp4",
    "Deadlifts": "/videos/exercises/deadlifts.mp4",

    "DeadMansPos": "/videos/exercises/deadmanspose.mp4", // Fixed naming
    "DeclinePushUps": "/videos/exercises/declinepushups.mp4",
    "DiamondPushUps": "/videos/exercises/diamondpushups.mp4",

    // ===== DIP VARIATIONS =====
    "Dips": "/videos/exercises/dips.mp4",
    "DipsHoldBottom": "/videos/exercises/dipsholdbottom.mp4",
    "DipsX": "/videos/exercises/dipsx.mp4",
    "DiveBombers": "/videos/exercises/divebombers.mp4",
    "DonkeyCalfRaises": "/videos/exercises/donkeycalfraises.mp4",
    "Dorsiflexion": "/videos/exercises/dorsiflexion.mp4",

    // ===== DUMBBELL EXERCISES =====
    "DoubleDumbbellRows": "/videos/exercises/doubledumbbellrows.mp4",
    "DownwardFacingDog": "/videos/exercises/downwardfacingdog.mp4",
    "DumbbellFarmersWalk": "/videos/exercises/dumbbellfarmerswalk.mp4",
    "DumbbellFlyes": "/videos/exercises/dumbbellflyes.mp4",
    "DumbbellJumpSquats": "/videos/exercises/dumbbelljumpsquats.mp4",
    "DumbbellKickbacks": "/videos/exercises/dumbbellkickbacks.mp4", // Fixed naming
    "DumbbellPushUpRow": "/videos/exercises/dumbbellpushuprow.mp4",
    "DumbbellReverseLunges": "/videos/exercises/dumbbellreverselunges.mp4",
    "DumbbellRows": "/videos/exercises/dumbbellrows.mp4",
    "DumbbellSquats": "/videos/exercises/dumbbellsquats.mp4",
    "DumbbellSquatsAndPress": "/videos/exercises/dumbbellsquatsandpress.mp4", // Fixed naming
    "DumbbellThruster": "/videos/exercises/dumbbellthruster.mp4",

    // ===== PUSH-UP VARIATIONS =====
    "ElevatedPushUps": "/videos/exercises/elevatedpushups.mp4",
    "ExplosiveRows": "/videos/exercises/explosiverows.mp4",

    // ===== FUNCTIONAL TRAINING =====
    "FarmerSquats": "/videos/exercises/farmersquats.mp4",
    "FarmersWalks": "/videos/exercises/farmerswalks.mp4",
    "FeetStackedCrunches": "/videos/exercises/feetstackedcrunches.mp4",
    "FigureFourStretch": "/videos/exercises/figurefourstretch.mp4",
    "FrontRackStretch": "/videos/exercises/frontrackstretch.mp4",
    "FrontRaises": "/videos/exercises/frontraises.mp4",
    "FullLegRaises": "/videos/exercises/fulllegraises.mp4",

    // ===== G87 RESISTANCE BAND SERIES =====
    "G87BentRow": "/videos/exercises/g87bentrow.mp4",
    "G87DeadLift": "/videos/exercises/g87deadlift.mp4",
    "G87DoorSmash": "/videos/exercises/g87doorsmash.mp4",
    "G87FlyBack": "/videos/exercises/g87flyback.mp4",
    "G87FlyBackX": "/videos/exercises/g87flybackx.mp4",
    "G87OneArmFrontRaise": "/videos/exercises/g87onearmfrontraise.mp4",
    "G87OneArmOverheadPress": "/videos/exercises/g87onearmoverheadpress.mp4",
    "G87OneArmPunch": "/videos/exercises/g87onearmpunch.mp4",
    "G87ReverseCurl": "/videos/exercises/g87reversecurl.mp4",
    "G87ReverseWristCurl": "/videos/exercises/g87reversewristcurl.mp4",
    "G87SeatedFrenchPress": "/videos/exercises/g87seatedfrenchpress.mp4",
    "G87StepWide": "/videos/exercises/g87stepwide.mp4",
    "G87SuperWideChop": "/videos/exercises/g87superwidechop.mp4",
    "G87WideGripBandSquat": "/videos/exercises/g87widegripbandsquat.mp4",
    "G87WideGripBentRow": "/videos/exercises/g87widegripbentrow.mp4",
    "G87WideGripDeadLift": "/videos/exercises/g87widegripdeadlift.mp4",
    "G87WideGripDoorSmash": "/videos/exercises/g87widegripdoorsmash.mp4",
    "G87WideGripOneArmFrontRaise": "/videos/exercises/g87widegriponearmfrontraise.mp4",    "G87WideGripReverseCurl": "/videos/exercises/g87widegripreversecurl.mp4",
    "G87WideStraightBarCurl": "/videos/exercises/g87widestraightbarcurl.mp4",

    // ===== GLUTE & HIP EXERCISES =====
    "GluteBridges": "/videos/exercises/glutebridges.mp4",

    // ===== ARM EXERCISES =====
    "HammerCurls": "/videos/exercises/hammercurls.mp4",
    "HandReleasePushUps": "/videos/exercises/handreleasepushups.mp4",
    "HandReleasePushUpsKnee": "/videos/exercises/handreleasepushupsknee.mp4",
    "HandstandPushUps": "/videos/exercises/handstandpushups.mp4",
    "HangingLegRaises": "/videos/exercises/hanginglegraises.mp4",

    // ===== CARDIO MOVEMENTS =====
    "HighKnees": "/videos/exercises/highknees.mp4",

    // ===== HIP EXERCISES =====
    "HipAbductionMachine": "/videos/exercises/hipabductionmachine.mp4",
    "HipAdductionMachine": "/videos/exercises/hipadductionmachine.mp4",
    "HipRaiseHold": "/videos/exercises/hipraisehold.mp4",
    "HipRaises": "/videos/exercises/hipraises.mp4",
    "HipRaisesLeft": "/videos/exercises/hipraisesleft.mp4",
    "HipRaisesRight": "/videos/exercises/hipraisesright.mp4",
    "HipThrust": "/videos/exercises/hipthrust.mp4",
    "HipThrusts": "/videos/exercises/hipthrusts.mp4",
    "HipTouches": "/videos/exercises/hiptouches.mp4",

    // ===== CORE HOLDS =====
    "HollowHold": "/videos/exercises/hollowhold.mp4",
    "HollowHoldToSuperman": "/videos/exercises/hollowholdtosuperman.mp4",
    "HollowRocks": "/videos/exercises/hollowrocks.mp4",
    "HollowRocksWithDumbbells": "/videos/exercises/hollowrockswithdumbbells.mp4",

    // ===== BACK EXERCISES =====
    "Hyperextension": "/videos/exercises/hyperextension.mp4",
    "Hyperextensions": "/videos/exercises/hyperextensions.mp4",

    // ===== COMPOUND MOVEMENTS =====
    "InchwormPushUps": "/videos/exercises/inchwormpushups.mp4",
    "InvertedRowsWithChairs": "/videos/exercises/invertedrowswithchairs.mp4",

    // ===== CORE ISOLATION =====
    "IsolatedCrunchesLeftAndRight": "/videos/exercises/isolatedcrunchesleftandright.mp4",
    "IsoSquats": "/videos/exercises/isosquats.mp4",

    // ===== JUMPING EXERCISES =====
    "JumpingJacks": "/videos/exercises/jumpingjacks.mp4",
    "JumpingLunges": "/videos/exercises/jumpinglunges.mp4",
    "JumpRope": "/videos/exercises/jumprope.mp4",
    "JumpSquats": "/videos/exercises/jumpsquats.mp4",
    "JumpSquats180": "/videos/exercises/jumpsquats180.mp4",

    // ===== KNEE-BASED EXERCISES =====
    "KneeKicks": "/videos/exercises/kneekicks.mp4",
    "KneePlank": "/videos/exercises/kneeplank.mp4",
    "KneePushUps": "/videos/exercises/kneepushups.mp4",
    "KneePushUpsWithRow": "/videos/exercises/kneepushupswithrow.mp4",
    "KneesToElbows": "/videos/exercises/kneestoelbows.mp4",

    // ===== SHOULDER EXERCISES =====
    "LateralRaises": "/videos/exercises/lateralraises.mp4",
    "LatPulldowns": "/videos/exercises/latpulldowns.mp4",
    "LeftIsolatedCrunches": "/videos/exercises/leftisolatedcrunches.mp4",

    // ===== LEG EXERCISES =====
    "LegCurls": "/videos/exercises/legcurls.mp4",
    "LegExtensions": "/videos/exercises/legextensions.mp4",
    "LegPress": "/videos/exercises/legpress.mp4",
    "LegRaises": "/videos/exercises/legraises.mp4",
    "LegRaises2": "/videos/exercises/legraises2.mp4",

    // ===== JUMPING MOVEMENTS =====
    "LineJumpsFrontAndBack": "/videos/exercises/linejumpsfrontandback.mp4",
    "LowLegRaiseHold": "/videos/exercises/lowlegraisehold.mp4",
    "LowLegRaises": "/videos/exercises/lowlegraises.mp4",
    "LSitHoldFromPullUpBar": "/videos/exercises/lsitholdfrompullupbar.mp4",

    // ===== LUNGE VARIATIONS =====
    "Lunges": "/videos/exercises/lunges.mp4",
    "Lunges2": "/videos/exercises/lunges2.mp4",

    // ===== MILITARY & STRENGTH =====
    "MilitaryPress": "/videos/exercises/militarypress.mp4",
    "MountainClimbers": "/videos/exercises/mountainclimbers.mp4",
    "MountainClimbers2": "/videos/exercises/mountainclimbers2.mp4",

    // ===== PULL-UP VARIATIONS =====
    "NegativePullUps": "/videos/exercises/negativepullups.mp4",

    // ===== OBLIQUE EXERCISES =====
    "ObliqueTwistLeftAndRight": "/videos/exercises/obliquetwistleftandright.mp4",
    "OneArmBurpees": "/videos/exercises/onearmburpees.mp4",
    "OverheadSquatWithDumbbells": "/videos/exercises/overheadsquatwithdumbbells.mp4",

    // ===== PANCAKE & SPECIALTY PUSH-UPS =====
    "PancakePushUps": "/videos/exercises/pancakepushups.mp4",
    "PecDeckMachine": "/videos/exercises/pecdeckmachine.mp4",
    "PendulumPushUps": "/videos/exercises/pendulumpushups.mp4",

    // ===== YOGA & STRETCHING =====
    "PigeonPose": "/videos/exercises/pigeonpose.mp4",
    "PikePushUps": "/videos/exercises/pikepushups.mp4",
    "PistolSquats": "/videos/exercises/pistolsquats.mp4",
    "PistolSquatsBeginner": "/videos/exercises/pistolsquatsbeginner.mp4",

    // ===== PLANK VARIATIONS =====
    "Plank": "/videos/exercises/plank.mp4",
    "Plank2": "/videos/exercises/plank2.mp4",
    "PlankPushUps": "/videos/exercises/plankpushups.mp4",
    "PlankToPushUp": "/videos/exercises/planktopushup.mp4",
    "PlankTricepsExtension": "/videos/exercises/planktricepsextension.mp4",
    "PlankVariations": "/videos/exercises/plankvariations.mp4",

    // ===== BICEP & ARM EXERCISES =====
    "PreacherCurls": "/videos/exercises/preachercurls.mp4",
    "PrisonerSquats": "/videos/exercises/prisonersquats.mp4",

    // ===== PULL-UP CORE =====
    "PullUp": "/videos/exercises/pullup.mp4",
    "PullUpBarCrunches": "/videos/exercises/pullupbarcrunches.mp4",
    "PullUps": "/videos/exercises/pullups.mp4",
    "PullUpsBarHold": "/videos/exercises/pullupsbarhold.mp4",

    // ===== PUSH-UP VARIATIONS =====
    "PushUp": "/videos/exercises/pushup.mp4",
    "PushUpJumps": "/videos/exercises/pushupjumps.mp4",
    "PushUps": "/videos/exercises/pushups.mp4",
    "PushUpsClose": "/videos/exercises/pushupsclose.mp4",
    "PushUpsHillClimbers": "/videos/exercises/pushupshillclimbers.mp4",
    "PushUpsSpiderman": "/videos/exercises/pushupsspiderman.mp4",
    "PushUpsWeighted": "/videos/exercises/pushupsweighted.mp4",
    "PushUpsWide": "/videos/exercises/pushupswide.mp4",
    "PushUpTwistKick": "/videos/exercises/pushuptwistkick.mp4",

    // ===== BOXING & PUNCHING =====
    "QuickPunches": "/videos/exercises/quickpunches.mp4",

    // ===== REAR DELT EXERCISES =====
    "RearDeltFlyes": "/videos/exercises/reardeltflyes.mp4",
    "RearDeltFlys": "/videos/exercises/reardeltflys.mp4",

    // ===== REVERSE MOVEMENTS =====
    "ReverseLunges": "/videos/exercises/reverselunges.mp4",
    "ReversePushUps": "/videos/exercises/reversepushups.mp4",
    "ReverseWristCurls": "/videos/exercises/reversewristcurls.mp4",
    "RightIsolatedCrunches": "/videos/exercises/rightisolatedcrunches.mp4",
    "RockingHorsePushUps": "/videos/exercises/rockinghorsepushups.mp4",
    "RunnersLunge": "/videos/exercises/runnerslunge.mp4",

    // ===== RUSSIAN EXERCISES =====
    "RussianDumbbellSwing": "/videos/exercises/russiandumbbellswing.mp4",
    "RussianTwists": "/videos/exercises/russiantwists.mp4",

    // ===== STRETCHING =====
    "SamsonStretch": "/videos/exercises/samsonstretch.mp4",
    "ScissorTwist": "/videos/exercises/scissortwist.mp4",
    "ScorpionStretch": "/videos/exercises/scorpionstretch.mp4",

    // ===== SEATED EXERCISES =====
    "SeatedCableRow": "/videos/exercises/seatedcablerow.mp4",
    "SeatedCableRows": "/videos/exercises/seatedcablerows.mp4",
    "SeatedCrunches": "/videos/exercises/seatedcrunches.mp4",
    "SeatedLegCircles": "/videos/exercises/seatedlegcircles.mp4",
    "SeatedLegScissors": "/videos/exercises/seatedlegscissors.mp4",
    "SeatedTwist": "/videos/exercises/seatedtwist.mp4",
    "SeatedTwistsLegsElevated": "/videos/exercises/seatedtwistslegselevated.mp4",

    // ===== BOXING & CONDITIONING =====
    "ShadowBoxing": "/videos/exercises/shadowboxing.mp4",
    "ShinTouches": "/videos/exercises/shintouches.mp4",
    "ShortJumps": "/videos/exercises/shortjumps.mp4",
    "ShoulderPress": "/videos/exercises/shoulderpress.mp4",
    "ShoulderToFloorStretch": "/videos/exercises/shouldertofloorstretch.mp4",
    "Shrugs": "/videos/exercises/shrugs.mp4",

    // ===== SIDE MOVEMENTS =====
    "SideObliquesTwistLeftRight": "/videos/exercises/sideobliquestwistleftright.mp4",
    "SidePlank": "/videos/exercises/sideplank.mp4",
    "SidePlankLeft": "/videos/exercises/sideplankleft.mp4",
    "SidePlankRaiseRight": "/videos/exercises/sideplankraiseright.mp4",
    "SidePlankThrusts": "/videos/exercises/sideplankthrusts.mp4",
    "SideToSideJumps": "/videos/exercises/sidetosidejumps.mp4",
    "SideToSideSkaterJumps": "/videos/exercises/sidetosideskaterjiups.mp4", // Fixed filename

    // ===== SPECIALIZED EXERCISES =====
    "SingleArmMedicineBallPushUps": "/videos/exercises/singlearmmedicineballpushups.mp4",
    "SitThrusts": "/videos/exercises/sitthrusts.mp4",
    "SkaterJumpsWithGroundTouch": "/videos/exercises/skaterjumpswithgroundtouch.mp4",
    "SkullCrushers": "/videos/exercises/skullcrushers.mp4",
    "SlowPushUps": "/videos/exercises/slowpushups.mp4",
    "SmallToLargeArmCircles": "/videos/exercises/smalltolargearmcircles.mp4",
    "SpartanPushUps": "/videos/exercises/spartanpushups.mp4",
    "SphinxPushUps": "/videos/exercises/sphinxpushups.mp4",

    // ===== SPIDERMAN VARIATIONS =====
    "SpidermanAndReach": "/videos/exercises/spidermanandreach.mp4",
    "SpidermanPlanks": "/videos/exercises/spidermanplanks.mp4",
    "SpidermanStretchWithReach": "/videos/exercises/spidermanstretchwithreach.mp4",
    "SpidermanWalkingPushUps": "/videos/exercises/spidermanwalkingpushups.mp4",

    // ===== FUNCTIONAL MOVEMENTS =====
    "Sprawls": "/videos/exercises/sprawls.mp4",
    "SquatAndPressWithDumbbells": "/videos/exercises/squatandpresswithdumbbells.mp4",
    "Squats": "/videos/exercises/squats.mp4",
    "StaggeredArmPushUps": "/videos/exercises/staggeredarmpushups.mp4",
    "StarJumpingJacks": "/videos/exercises/starjumpingjacks.mp4",
    "StepBackLunges": "/videos/exercises/stepbacklunges.mp4",
    "StepUps": "/videos/exercises/stepups.mp4",
    "StepUps2": "/videos/exercises/stepups2.mp4",
    "StiffLeggedDeadlift": "/videos/exercises/stiffleggeddeadlift.mp4",
    "StraddleStretch": "/videos/exercises/straddlestretch.mp4",
    "StraightArmPlankKneesToElbows": "/videos/exercises/straightarmplankkneestoelbows.mp4",
    "StraightPunches": "/videos/exercises/straightpunches.mp4",
    "SumoSquats": "/videos/exercises/sumosquats.mp4",
    "SumoWalks": "/videos/exercises/sumowalks.mp4",
    "SupermanRocks": "/videos/exercises/supermanrocks.mp4",
    "SwissBallPushUps": "/videos/exercises/swissballpushups.mp4",
    "SwissBallVups": "/videos/exercises/swissballvups.mp4",

    // ===== T-BAR & SPECIALTY =====
    "TBarRows": "/videos/exercises/tbarrows.mp4",
    "TickTocks": "/videos/exercises/ticktocks.mp4",
    "ToesToBar": "/videos/exercises/toestobar.mp4",
    "ToeTouches": "/videos/exercises/toetouches.mp4",
    "TPushUps": "/videos/exercises/tpushups.mp4",

    // ===== TRIANGLE RESISTANCE BAND SERIES =====
    "TriangleBentRow": "/videos/exercises/trianglebentrow.mp4",
    "TriangleBoxing": "/videos/exercises/triangleboxing.mp4",
    "TriangleBriefcaseRow": "/videos/exercises/trianglebriefcaserow.mp4",
    "TriangleDoubleBriefcase": "/videos/exercises/triangledoublebriefcase.mp4",
    "TriangleFloorBenchPress": "/videos/exercises/trianglefloorbenchtpress.mp4",
    "TriangleFloorCrusher": "/videos/exercises/trianglefloorcrusher.mp4",
    "TriangleFrontRaise": "/videos/exercises/trianglefrontraise.mp4",
    "TriangleJet": "/videos/exercises/trianglejet.mp4",
    "TriangleLiftAndPunch": "/videos/exercises/triangleliftandpunch.mp4",
    "TriangleLiftOff": "/videos/exercises/triangleliftoff.mp4",
    "TriangleOneArmFrontRaise": "/videos/exercises/triangleonearmfrontraise.mp4",
    "TriangleOneArmRow": "/videos/exercises/triangleonearmrow.mp4",
    "TriangleOneArmSwing": "/videos/exercises/triangleonearmswing.mp4",
    "TriangleOneArmTwist": "/videos/exercises/triangleonearmtwist.mp4",
    "TriangleOverheadPress": "/videos/exercises/triangleoverheadpress.mp4",
    "TrianglePunchDefend": "/videos/exercises/trianglepunchdefend.mp4",
    "TriangleRocket": "/videos/exercises/trianglerocket.mp4",
    "TriangleSlowCurl": "/videos/exercises/triangleslowcurl.mp4",
    "TriangleTiltAndPour": "/videos/exercises/triangletiltandpour.mp4",
    "TriangleTorso": "/videos/exercises/triangletorso.mp4",
    "TriangleUprightRow": "/videos/exercises/triangleuprightrow.mp4",
    "TriangleUpsideDownPull": "/videos/exercises/triangleupsidedownpull.mp4",
    "TriangleWideFly": "/videos/exercises/trianglewidefly.mp4",
    "TriangleWings": "/videos/exercises/trianglewings.mp4",

    // ===== TRICEP EXERCISES =====
    "TricepDips": "/videos/exercises/tricepdips.mp4",
    "TricepExtensions": "/videos/exercises/tricepextensions.mp4",
    "TricepPress": "/videos/exercises/triceppress.mp4",
    "TuckJumps": "/videos/exercises/tuckjumps.mp4",
    "Twisters": "/videos/exercises/twisters.mp4",

    // ===== SPECIALTY PUSH-UPS =====
    "UnderTheFencePushUpsFromKnees": "/videos/exercises/underthefencepushupsfromknees.mp4",
    "UnweightedGoodMornings": "/videos/exercises/unweightedgoodmornings.mp4",
    "UpperBodyHollowHoldKnee": "/videos/exercises/upperbodyhollowholdknee.mp4",
    "UpperLegRaise": "/videos/exercises/upperlegraise.mp4",
    "UprightRows": "/videos/exercises/uprightrows.mp4",
    "UpwardDog": "/videos/exercises/upwarddog.mp4",

    // ===== V EXERCISES =====
    "Vups": "/videos/exercises/vups.mp4",

    // ===== WALL EXERCISES =====
    "WallSit": "/videos/exercises/wallsit.mp4",
    "WallWalkouts": "/videos/exercises/wallwalkouts.mp4",
    "WarriorIII": "/videos/exercises/warrioriii.mp4",
    "WideKneePushUps": "/videos/exercises/widekneepushups.mp4",
    "WristCurls": "/videos/exercises/wristcurls.mp4",

    // ===== EXERCISE ALIASES & ALTERNATIVE NAMES =====
    // These handle different naming conventions used in exerciseData.js
    "DumbbellKickBacks": "/videos/exercises/dumbbellkickbacks.mp4", // Fixed from "DumbbellKickbacks"
    "DumbbellSquatsandPress": "/videos/exercises/dumbbellsquatsandpress.mp4", // Alternative naming
    "DeadMansPose": "/videos/exercises/deadmanspose.mp4", // Fixed filename issue
    "SquatAndPresswithDumbbells": "/videos/exercises/squatandpresswithdumbbells.mp4", // Alternative naming



    // ===== FALLBACK FOR ANY MISSING EXERCISES =====
    // Default video for any exercise that might be missing
    "DefaultExercise": "/videos/exercises/pushups.mp4",


};

/**
 * Helper function to get video URL for an exercise
 * @param {string} exerciseName - Name of the exercise
 * @returns {string} - Video URL or fallback
 */
export function getExerciseVideo(exerciseName) {
    // Try exact match first
    if (exerciseVideos[exerciseName]) {
        return exerciseVideos[exerciseName];
    }

    // Try case-insensitive match
    const lowerName = exerciseName.toLowerCase();
    for (const [key, value] of Object.entries(exerciseVideos)) {
        if (key.toLowerCase() === lowerName) {
            return value;
        }
    }

    // Try partial match (useful for variations)
    for (const [key, value] of Object.entries(exerciseVideos)) {
        if (key.toLowerCase().includes(lowerName) || lowerName.includes(key.toLowerCase())) {
            return value;
        }
    }

    // Fallback to default
    console.warn(`Video not found for exercise: ${exerciseName}, using default`);
    return exerciseVideos.DefaultExercise;
}

/**
 * Get all available exercise names
 * @returns {Array} - Array of all exercise names
 */
export function getAllExerciseNames() {
    return Object.keys(exerciseVideos).filter(key => key !== 'DefaultExercise');
}

/**
 * Check if an exercise has a video
 * @param {string} exerciseName - Name of the exercise
 * @returns {boolean} - True if video exists
 */
export function hasExerciseVideo(exerciseName) {
    return !!exerciseVideos[exerciseName];
}